/*jshint esversion: 11*/
/* API calls for lake-service components.
 * HISTORY:
 * V260604.1: Added downloadLakeRejects() + Merged Aref's changes (added $http2).
 * V260319.1: Added Settings methods: getSettings(), createSettings() and updateSettings().
 * V260212.1: Added deleteLakeDirectory().
 * V251027.1: Added Dashboards methods: getDashboards(), getDashboard(), createDashboard(), updateDashboard() and deleteDashboard().
 * V250902.1: Added getAiQueryResult().
 * V250804.1: Modified getSchemas() to handle the new year format +
 *    Modified _parseError to return the error message when there was no schemas in the specified range.
 * V250701.1: Modified getQueryResult() to set url according to the model.
 * V250625.1: Added getQueryResult().
 * V250618.1: Added getSchemas().
 * V250617.1: 1st version/release.
 */

import axios from 'axios';
// import { sleep } from '../mixins/bt-mixin.js';

let _debug;

function _log(message, showAlert) {
   if (_debug) {
      const msg = `-----cs-api-service V260604.1 says => ${message}`;
      console.log(msg);
      if (showAlert)
         alert(msg);
   }
}

function _initResult() {
   return {
      data: null,
      message: null,
      logout: false,
      timeout: false
   };
}

function _parseError(error, data =null) { //, displayError =true
   _log(`in _parseError(): error=${JSON.stringify(error)}, data=${data}`);
   const result = _initResult();
   if (error.response) {
      if (error.response.status === 401)  //unauthorized
         result.logout = true;
      else {
         let msg;
         if (error.response.status === 400) { //V250804: BadRequest
            result.message = _parseIOErrMsg(error.response?.data?.error) || error.response?.data?.error;
            if (result.message) result.data = data;
         } else if (error.response.status === 403)  //V250616: forbidden
            msg = 'Access Denied: Sorry, you do not have permission to view the resource.';
         else if (error.response.status === 404) {  //not found
            result.data = data;
         } else if (error.response.status === 504) {
            result.data = data;
            result.timeout = true;
         }

         if (result.data === null) {
            result.message = `${msg || JSON.stringify(error.response.data)} (status=${error.response.status})`;
         }
      }
   } else if (error.message) {
      result.message = error.message;
   } else {
      result.message = error;
   }

   // if (displayError && result.message)
   //    alert(result.message);

   return result;
}

function _parseIOErrMsg(errorMessage) {
   // alert(`in _parseIOErrMsg(): errorMessage=${errorMessage}`);
   const match = errorMessage?.match(/\/data\/\d+\/(\d{4})\/(\d{1,2})\//);
   // if (!match) return "No valid date found in the error message.";
   if (match) {
      const [ , year, monthStr ] = match;
      const monthNum = parseInt(monthStr, 10);
      const date = new Date(`${year}-${monthNum}-01`);
      const monthName = date.toLocaleString('en-US', { month: 'long' });
      return `You don't have any data for '${monthName} ${year}'. Either adjust your date range to exclude this month or upload the missing data by creating a new ETL.`;
   }
}

export class APIService {
   constructor(jwt, token, debug, isActualEndpoint, path) {
      // alert('in APIService: debug=' + debug +
      //    '\nisActualEndpoint=' + isActualEndpoint +
      //    '\npath=' + path +
      //    '\ntoken=' + token
      // );
      _debug = debug;
      // this.jwt = jwt ? jwt : JSON.parse(Buffer.from(token.split('.')[1], 'base64'));
      // this.isActualEndpoint = isActualEndpoint;
      this.$http = axios.create({
         baseURL: process.env.VUE_APP_EDGE_SERVICE_ENDPOINT + 
            (isActualEndpoint ? (path ? path : '/api/lake-service/v1/') : ''),
         headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
         }
      });

      this.$http2 = axios.create({
         baseURL: process.env.VUE_APP_EDGE_SERVICE_ENDPOINT + 
            (isActualEndpoint ? (path ? path : '/api/lake-service/v2/') : ''),
         headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
         }
      });
   }

   /********************************/
   /*         DIRECTORIES          */
   /********************************/

   async getS3Directories() {
      _log('in getS3Directories()...');
      let result = _initResult();

      try {
         const url = 'transitions/directory-s3';
         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
         // await sleep(10000);
         // result.data = [
         //    {
         //       "name": "2024",
         //       "type": "directory",
         //       "path": "15972/2024/",
         //       "children": [
         //          {
         //             "name": "4",
         //             "type": "directory",
         //             "path": "15972/2024/4/",
         //             "children": [
         //                {
         //                      "name": "2024-04.csv",
         //                      "type": "file",
         //                      "path": "15972/2024/4/2024-04.csv",
         //                      "size": 124505,
         //                      "modified": "2025-05-23T17:59:52.000Z"
         //                }
         //             ]
         //          },
         //          {
         //             "name": "3",
         //             "type": "directory",
         //             "path": "15972/2024/3/",
         //             "children": [
         //                {
         //                   "name": "2024-03.csv",
         //                   "type": "file",
         //                   "path": "15972/2024/3/2024-03.csv",
         //                   "size": 124505,
         //                   "modified": "2025-05-23T17:59:52.000Z"
         //                }
         //             ]
         //          },
         //          {
         //             "name": "2",
         //             "type": "directory",
         //             "path": "15972/2024/2/",
         //             "children": [
         //                {
         //                   "name": "2024-02.csv",
         //                   "type": "file",
         //                   "path": "15972/2024/2/2024-02.csv",
         //                   "size": 124505,
         //                   "modified": "2025-05-23T17:59:52.000Z"
         //                }
         //             ]
         //          },
         //          {
         //             "name": "1",
         //             "type": "directory",
         //             "path": "15972/2024/1/",
         //             "children": [
         //                {
         //                   "name": "2024-01.csv",
         //                   "type": "file",
         //                   "path": "15972/2024/1/2024-01.csv",
         //                   "size": 124505,
         //                   "modified": "2025-05-23T17:59:52.000Z"
         //                }
         //             ]
         //          }
         //       ]
         //    },
         //    {
         //       "name": "2025",
         //       "type": "directory",
         //       "path": "15972/2025/",
         //       "children": [
         //          {
         //             "name": "1",
         //             "type": "directory",
         //             "path": "15972/2025/1/",
         //             "children": [
         //                {
         //                   "name": "2025-01.csv",
         //                   "type": "file",
         //                   "path": "15972/2025/1/2025-01.csv",
         //                   "size": 124505,
         //                   "modified": "2025-05-23T17:59:52.000Z"
         //                }
         //             ]
         //          }
         //       ]
         //    }
         // ];
      } catch (error) {
         result = _parseError(error, []);
      }

      return result;
   }

   async getLakeDirectories() {
      _log('in getLakeDirectories()...');
      let result = _initResult();

      try {
         const url = 'transitions/directory-lake';
         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         result = _parseError(error, []);
         // // await sleep(5000);
         // result.data = [
         //    {
         //       "name": "2024",
         //       "type": "directory",
         //       "size": 6144,
         //       "modified": "2025-05-29T18:54:16.661Z",
         //       "children": [
         //          {
         //             "name": "4",
         //             "type": "directory",
         //             "size": 6144,
         //             "modified": "2025-05-29T18:54:16.856Z",
         //             "children": [
         //                {
         //                   "name": "2024-04.csv",
         //                   "type": "file",
         //                   "size": 124505,
         //                   "modified": "2025-05-29T18:54:16.807Z"
         //                },
         //                {
         //                   "name": "2024-04.parquet",
         //                   "type": "file",
         //                   "size": 83428,
         //                   "modified": "2025-05-29T18:54:16.921Z"
         //                }
         //             ]
         //          }
         //       ]
         //    }
         // ];
      }

      return result;
   }

   async deleteLakeDirectory(lakeYear, lakeMonth) {
      _log(`in deleteLakeDirectory(): lakeYear=${lakeYear}, lakeMonth=${lakeMonth}`);
      let result = _initResult();

      try {
         const url = `transitions/delete/${lakeYear}/${lakeMonth}`;
         const response = await this.$http.delete(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         result = _parseError(error);
      }

      return result;
   }

   async downloadLakeRejects(lakeYear, lakeMonth) {
      _log(`in downloadLakeRejects(): lakeYear=${lakeYear}, lakeMonth=${lakeMonth}`);
      let result = _initResult();

      try {
         const url = `transitions/rejects/${lakeYear}/${lakeMonth}`;
         const response = await this.$http.get(
            url,
            { responseType: 'blob' }
         );
         result.data = response.data;
      } catch (error) {
         result = _parseError(error);
      }

      return result;
   }

   /********************************/
   /*           SCHEMAS            */
   /********************************/

   async getSchemas(lake) {
      _log(`in getSchemas(): lake=${JSON.stringify(lake)}`);
      // alert(`in getSchemas(): lake=${JSON.stringify(lake)}`);
      let result = _initResult();

      try {
         // const url = `aggregate/schema/${encodeURIComponent('2024/7')}/|`;
         // const url = `aggregate/schema/${encodeURIComponent('2025/1')}/|`;
         // const url = `aggregate/schema/${encodeURIComponent('2024/7,2024/8')}/|`;
         const url = `aggregate/schema/${encodeURIComponent(lake.year)}/${lake.month}`;
         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         result = _parseError(error, []); //, true, true
         // await sleep(5000);
         // result.data = [
         //    {
         //       "column_name": "_id",
         //       "column_type": "VARCHAR",
         //       "null": "YES",
         //       "key": null,
         //       "default": null,
         //       "extra": null
         //    },
         //    {
         //       "column_name": "dedupHash",
         //       "column_type": "VARCHAR",
         //       "null": "YES",
         //       "key": null,
         //       "default": null,
         //       "extra": null
         //    },
         //    {
         //       "column_name": "app_code",
         //       "column_type": "VARCHAR",
         //       "null": "YES",
         //       "key": null,
         //       "default": null,
         //       "extra": null
         //    },
         //    {
         //       "column_name": "event_code",
         //       "column_type": "VARCHAR",
         //       "null": "YES",
         //       "key": null,
         //       "default": null,
         //       "extra": null
         //    },
         //    {
         //       "column_name": "event_date",
         //       "column_type": "TIMESTAMP",
         //       "null": "YES",
         //       "key": null,
         //       "default": null,
         //       "extra": null
         //    },
         //    {
         //       "column_name": "event_element",
         //       "column_type": "VARCHAR",
         //       "null": "YES",
         //       "key": null,
         //       "default": null,
         //       "extra": null
         //    },
         //    {
         //       "column_name": "event_path",
         //       "column_type": "VARCHAR",
         //       "null": "YES",
         //       "key": null,
         //       "default": null,
         //       "extra": null
         //    },
         //    {
         //       "column_name": "filename",
         //       "column_type": "VARCHAR",
         //       "null": "YES",
         //       "key": null,
         //       "default": null,
         //       "extra": null
         //    }
         // ];
      }

      return result;
   }

   /********************************/
   /*          AGGREGATE           */
   /********************************/

   async getQueryResult(query) {
      _log('in getQueryResult()...');
      let result = _initResult();

      try {
         const url = `aggregate/${query.type}`;
         const response = await this.$http.post(url, query);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         result = _parseError(error, []);
         // await sleep(5000);
      }

      return result;
   }

   /********************************/
   /*           AI-AGENT           */
   /********************************/

   // V250902
   async getAiQueryResult(model, query) {
      _log('in getAiQueryResult()...');
      let result = _initResult();

      try {
         const url = `ai-agent/${model}`;
         const response = await this.$http2.post(url, query);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         result = _parseError(error, {});
         // await sleep(5000);
      }

      return result;
   }

   /********************************/
   /*          DASHBOARDS          */
   /********************************/

   async getDashboards() {
      // const response = await axios({
      //    url: process.env.VUE_APP_EDGE_SERVICE_ENDPOINT + '/api/contact-service/v1/dashboards',
      //    method: 'GET',
      //    headers: {
      //       'Content-Type': 'application/json',
      //       'Authorization': 'Bearer ' + this.token
      //    }
      // });

      _log('in getDashboards()');
      let result = _initResult();

      try {
         let url = '/dashboards';
         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         result = _parseError(error, []);
      }

      return result;
   }

   async getDashboard(id) {
      _log('in getDashboard(): id=' + id);
      let result = _initResult();

      try {
         let url = '/dashboards/' + id;
         const response = await this.$http.get(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         result = _parseError(error, {});
      }

      return result;
   }

   async createDashboard(ddl) {
      _log('createDashboard(): importData=' + JSON.stringify(ddl));
      let result = _initResult();

      try {
         const response = await this.$http.post('/dashboards', ddl);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         result = _parseError(error, {});
      }

      return result;
   }

   async updateDashboard(ddl) {
      _log(`in updateDashboard(): ddl=${JSON.stringify(ddl)}`);
      let result = _initResult();

      try {
         const response = await this.$http.put(`/dashboards/${ddl._id}`, ddl);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         result = _parseError(error);
      }

      return result;
   }

   async deleteDashboard(id) {
      _log('in deleteDashboard(): id=' + id);
      let result = _initResult();

      try {
         const url = `/dashboards/${id}`;
         const response = await this.$http.delete(url);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         result = _parseError(error);
      }

      return result;
   }

   /********************************/
   /*           SETTINGS           */
   /********************************/

   async getSettings() {
      _log('in getSettings()...');
      let result = _initResult();

      try {
         const response = await this.$http.get('/settings');
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         result = _parseError(error, {});
      }

      return result;
   }

   async createSettings(settingsData) {
      _log('in createSettings(): settingsData=' + JSON.stringify(settingsData));
      let result = _initResult();

      try {
         const response = await this.$http.post('/settings', settingsData);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         result = _parseError(error);
      }

      return result;
   }

   async updateSettings(settingsData) {
      _log('in updateSettings(): settingsData=' + JSON.stringify(settingsData));
      let result = _initResult();

      try {
         const response = await this.$http.put(`/settings/${settingsData._id}`, settingsData);
         _log(`response=${JSON.stringify(response)}`);
         result.data = response.data;
      } catch (error) {
         result = _parseError(error);
      }

      return result;
   }
}